var win = window;

export var raf = win.requestAnimationFrame
  || win.webkitRequestAnimationFrame
  || win.mozRequestAnimationFrame
  || win.msRequestAnimationFrame
  || function(cb) { return setTimeout(cb, 16); };



//////////////////
// WEBPACK FOOTER
// /Users/maciejwarych/Local Sites/vidoq/app/public/wp-content/themes/vidoq/node_modules/tiny-slider/src/helpers/raf.js
// module id = 4
// module chunks = 0